import { Avatar, Box, IconButton, TextField, Typography } from '@mui/material';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SendIcon from '@mui/icons-material/Send';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VerifiedIcon from '@mui/icons-material/Verified';
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CONTATOS } from '../../global/contatos';
import { useAuth } from '../../context/AuthContext';
import Header from '../../components/Header';
import { LandingNavbar } from '../Welcome';

// ─── Paleta do Assistente ────────────────────────────────────────────────────
const COLORS = {
    primary: '#43D196',
    primaryDark: '#1E7B54',
    bg: '#F1F1F1',
    white: '#fff',
    greyDark: '#686868',
    userBubble: '#DCF8C6',
    botBubble: '#fff',
};

// ─── Paleta do WhatsApp ──────────────────────────────────────────────────────
const WA = {
    header: '#f0f2f5',
    headerText: '#111b21',
    headerSub: '#667781',
    chatBg: '#eae6df',
    sentBubble: '#d9fdd3',
    receivedBubble: '#ffffff',
    inputArea: '#f0f2f5',
    inputField: '#ffffff',
    sendBtn: '#00a884',
    timestamp: '#667781',
    icon: '#54656f',
};

// ─── Link externo do suporte ─────────────────────────────────────────────────
const WHATSAPP_SUPORTE = 'https://wa.me/556199113830';

// ─── Árvore de menus da URA ──────────────────────────────────────────────────
const MENU_TREE = {
    root: {
        message:
            'Olá 👋 Seja bem-vindo(a) à Empiria.\nPosso te ajudar com alguma dúvida?\nEscolha uma opção abaixo:\n\n1️⃣ O que é a Empiria?\n2️⃣ Como funcionam os encontros?\n3️⃣ Quero participar como Conviva\n4️⃣ Quero ser Anfitrião\n5️⃣ Valores e condições\n6️⃣ Segurança e Privacidade\n7️⃣ Falar com nossa equipe\n8️⃣ Fazer uma denúncia',
        options: {
            '1': 'o_que_e',
            '2': 'como_funcionam',
            '3': 'conviva',
            '4': 'anfitriao',
            '5': 'valores_condicoes',
            '6': 'seguranca',
            '7': 'falar_equipe',
            '8': 'denuncia',
        },
    },

    o_que_e: {
        response: 'A Empiria é uma plataforma que conecta pessoas que buscam orientação com anfitriões experientes, por meio de encontros online ao vivo e conteúdo em formato de podcast por aqueles que irão apenas assistir os encontros.\nNosso foco é conexão humana, aprendizado prático e troca real, sem superficialidade.',
        message: 'Digite 0 para voltar ao menu inicial.',
        options: { '0': 'root' },
    },

    como_funcionam: {
        response: 'Os encontros são realizados online, por videoconferência.\nO anfitrião agenda e define o conteúdo, as datas e os horários disponíveis para os encontros.\nVocê pode participar por inscrição, seleção ou agendamento direto, conforme as regras de cada encontro.',
        message: 'Digite 0 para voltar ao menu inicial.',
        options: { '0': 'root' },
    },

    conviva: {
        response: 'Excelente 👏\nVocê poderá se inscrever nos encontros disponíveis e escolher os temas que mais fazem sentido para você.',
        message: 'Quer que eu envie o link para cadastro?\n\n1️⃣ Sim\n2️⃣ Não',
        options: { '1': 'conviva_link', '2': 'root' },
    },
    conviva_link: {
        message: 'Aqui está o link para se cadastrar como Conviva:\n\nDigite 0 para voltar ao menu inicial.',
        link: { text: 'Clique aqui para se cadastrar', to: '/criar-conta' },
        options: { '0': 'root' },
    },

    anfitriao: {
        response: 'Que ótimo 🙌\nEstamos sempre buscando pessoas dispostas a compartilhar experiências reais e inspiradoras.',
        message: 'Posso te enviar o link para cadastrar-se como anfitrião?\n\n1️⃣ Sim\n2️⃣ Não',
        options: { '1': 'anfitriao_link', '2': 'root' },
    },
    anfitriao_link: {
        message: 'Aqui está o link para se cadastrar como Anfitrião:\n\nDigite 0 para voltar ao menu inicial.',
        link: { text: 'Clique aqui para se cadastrar', to: '/criar-conta?sign=encontrado' },
        options: { '0': 'root' },
    },

    valores_condicoes: {
        message:
            'Escolha uma opção:\n\n1️⃣ Valores\n2️⃣ Condições\n\n0️⃣ Voltar\n9️⃣ Menu principal',
        options: { '1': 'valores', '2': 'condicoes', '0': 'root', '9': 'root' },
    },
    valores: {
        response: 'Alguns encontros são gratuitos e outros podem ter investimento definido pelo anfitrião, o que será sempre informado antes da confirmação.',
        message: '1️⃣ Valores\n2️⃣ Condições\n\n0️⃣ Voltar\n9️⃣ Menu principal',
        options: { '1': 'valores', '2': 'condicoes', '0': 'valores_condicoes', '9': 'root' },
    },
    condicoes: {
        message:
            'Escolha o tipo de condição:\n\n1️⃣ Agendamento gratuito\n2️⃣ Agendamento direto\n3️⃣ Seleção\n4️⃣ Valores\n\n0️⃣ Voltar\n9️⃣ Menu principal',
        options: { '1': 'agendamento_gratuito', '2': 'agendamento_direto', '3': 'sorteio', '4': 'valores', '0': 'valores_condicoes', '9': 'root' },
    },
    agendamento_gratuito: {
        response: 'O Anfitrião irá realizar o encontro com aquele que primeiro agendar sem nenhum investimento.',
        message: '1️⃣ Agendamento gratuito\n2️⃣ Agendamento direto\n3️⃣ Seleção\n4️⃣ Valores\n\n0️⃣ Voltar\n9️⃣ Menu principal',
        options: { '1': 'agendamento_gratuito', '2': 'agendamento_direto', '3': 'sorteio', '4': 'valores', '0': 'condicoes', '9': 'root' },
    },
    agendamento_direto: {
        response: 'O Anfitrião irá realizar o encontro com aquele que primeiro investir o valor por ele estipulado.',
        message: '1️⃣ Agendamento gratuito\n2️⃣ Agendamento direto\n3️⃣ Seleção\n4️⃣ Valores\n\n0️⃣ Voltar\n9️⃣ Menu principal',
        options: { '1': 'agendamento_gratuito', '2': 'agendamento_direto', '3': 'sorteio', '4': 'valores', '0': 'condicoes', '9': 'root' },
    },
    sorteio: {
        response: 'O Anfitrião irá realizar o encontro por intermédio de uma seleção realizada entre aqueles que investir o valor por ele estipulado na inscrição. Nesta condição, os Convivas que não forem selecionados poderão assistir o encontro como espectador.',
        message: '1️⃣ Agendamento gratuito\n2️⃣ Agendamento direto\n3️⃣ Seleção\n4️⃣ Valores\n\n0️⃣ Voltar\n9️⃣ Menu principal',
        options: { '1': 'agendamento_gratuito', '2': 'agendamento_direto', '3': 'sorteio', '4': 'valores', '0': 'condicoes', '9': 'root' },
    },

    seguranca: {
        response: 'A Empiria prioriza um ambiente seguro e respeitoso.\nTodos os participantes aceitam termos de uso e política de privacidade e convivência.\nDados pessoais são protegidos conforme a legislação vigente.',
        message: 'Quer receber o link de acesso aos termos da Empiria?\n\n1️⃣ Sim\n2️⃣ Não',
        options: { '1': 'seguranca_link', '2': 'root' },
    },
    seguranca_link: {
        message: 'Aqui está o link dos termos da Empiria:\n\nDigite 0 para voltar ao menu inicial.',
        link: { text: 'Clique aqui para acessar os termos e políticas', to: '/politicas' },
        options: { '0': 'root' },
    },

    // O item 12.1 dos Termos promete dois canais de denuncia: o chat da
    // Plataforma e o e-mail. Este e o comeco do primeiro; o segundo e o
    // endereco abaixo, que o documento define.
    denuncia: {
        response: `Para denunciar uma conduta, um encontro ou um usuário, conte o que aconteceu para a nossa equipe. Se puder, informe o nome do encontro e a data.\nToda denúncia é analisada pela Empiria.`,
        message: 'Como você prefere denunciar?\n\n1️⃣ Pelo chat da Empiria\n2️⃣ Por e-mail\n0️⃣ Voltar ao menu inicial',
        options: { '1': 'denuncia_chat', '2': 'denuncia_email', '0': 'root' },
    },
    denuncia_chat: {
        message: 'Vamos abrir a sua denúncia no chat de atendimento.\n\nDigite 0 para voltar ao menu inicial.',
        link: { text: 'Abrir denúncia no chat', to: '/atendimento?assunto=denuncia' },
        options: { '0': 'root' },
    },
    denuncia_email: {
        response: `Escreva para ${CONTATOS.denuncias} contando o que aconteceu.`,
        message: 'Digite 0 para voltar ao menu inicial.',
        options: { '0': 'root' },
    },

    falar_equipe: {
        message: `Se sua dúvida for diferente dessas opções, digite 1 que um dos colaboradores de nossa equipe irá atendê-lo pessoalmente em horário comercial das 8h às 18h em dias úteis.\nVocê também pode escrever para ${CONTATOS.suporte}.`,
        options: { '1': 'falar_equipe_link', '0': 'root' },
    },
    falar_equipe_link: {
        message: 'Você será redirecionado para o nosso atendimento:\n\nDigite 0 para voltar ao menu inicial.',
        link: { text: 'Clique aqui para falar com a equipe', to: WHATSAPP_SUPORTE, external: true },
        options: { '0': 'root' },
    },
};

// ─── Hook de mensagens da URA ────────────────────────────────────────────────
const useChatMessages = () => {
    const { logged, user } = useAuth();
    const isHost = Boolean(user?.profile);

    const getDisabledOptions = (nodeKey) => {
        if (nodeKey !== 'root') return [];
        const disabled = [];
        if (logged) disabled.push('3');
        if (isHost) disabled.push('4');
        return disabled;
    };

    const getMenuMessage = (nodeKey) => {
        let text = MENU_TREE[nodeKey].message;
        if (nodeKey === 'root') {
            if (logged) {
                text = text.replace(
                    '3️⃣ Quero participar como Conviva',
                    '3️⃣ Quero participar como Conviva (você já possui uma conta)'
                );
            }
            if (isHost) {
                text = text.replace(
                    '4️⃣ Quero ser Anfitrião',
                    '4️⃣ Quero ser Anfitrião (você já é anfitrião)'
                );
            }
        }
        return text;
    };

    const [messages, setMessages] = useState([
        { id: 1, from: 'bot', text: '' },
    ]);
    const [initialized, setInitialized] = useState(false);
    const [input, setInput] = useState('');
    const [currentNode, setCurrentNode] = useState('root');

    useEffect(() => {
        // Recria a mensagem inicial quando os dados do usuario ficam disponiveis
        if (!initialized || messages.length === 1) {
            setMessages([{ id: 1, from: 'bot', text: getMenuMessage('root') }]);
            setInitialized(true);
        }
    }, [logged, user?.profile]);

    const disabledOptions = getDisabledOptions(currentNode);
    const validOptions = Object.keys(MENU_TREE[currentNode].options || {}).filter(o => !disabledOptions.includes(o));

    const handleInputChange = (value) => {
        if (value === '') return setInput('');
        if (value.length > 1) return;
        if (!/^\d$/.test(value)) return;
        if (!validOptions.includes(value)) return;
        setInput(value);
    };

    const getNow = () => new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

    const handleSend = () => {
        const text = input.trim();
        if (!text) return;

        const now = getNow();
        const userMessage = { id: Date.now(), from: 'user', text, time: now };

        const node = MENU_TREE[currentNode];
        const nextNodeKey = node.options[text];
        const nextNode = MENU_TREE[nextNodeKey];
        const menuText = getMenuMessage(nextNodeKey);

        const newMessages = [userMessage];

        // Se o nó tem response, cria um balão separado para a resposta
        if (nextNode.response) {
            newMessages.push({
                id: Date.now() + 1, from: 'bot', time: now,
                text: nextNode.response,
                link: nextNode.link || null,
            });
        }

        // Balão do menu seletor
        newMessages.push({
            id: Date.now() + 2, from: 'bot', time: now,
            text: menuText,
            link: !nextNode.response ? (nextNode.link || null) : null,
        });

        setMessages(prev => [...prev, ...newMessages]);
        setCurrentNode(nextNodeKey);

        setInput('');
    };

    const handleKeyDown = e => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    return { messages, input, handleInputChange, handleSend, handleKeyDown };
};

// ─── Link clicável dentro das bolhas ─────────────────────────────────────────
const ChatLink = ({ link }) => {
    const navigate = useNavigate();
    if (!link) return null;

    const handleClick = (e) => {
        e.preventDefault();
        if (link.external) {
            window.open(link.to, '_blank', 'noopener,noreferrer');
        } else {
            navigate(link.to);
        }
    };

    return (
        <Typography
            component="a"
            href={link.to}
            onClick={handleClick}
            sx={{
                display: 'block',
                fontSize: 14,
                color: '#0d6efd',
                textDecoration: 'underline',
                cursor: 'pointer',
                mt: 0.5,
                '&:hover': { color: '#0a58ca' },
            }}
        >
            {link.text}
        </Typography>
    );
};

// ─── Texto do bot com linhas desabilitadas em cinza ──────────────────────────
const DISABLED_MARKERS = ['(você já possui uma conta)', '(você já é anfitrião)'];

const BotText = ({ text }) => {
    const lines = text.split('\n');
    return (
        <Typography component="div" sx={{ fontSize: 14, color: '#111', lineHeight: 1.5, whiteSpace: 'pre-line' }}>
            {lines.map((line, i) => {
                const isDisabled = DISABLED_MARKERS.some(marker => line.includes(marker));
                return (
                    <span key={i} style={isDisabled ? { color: '#ccc', textDecoration: 'line-through' } : undefined}>
                        {line}
                        {i < lines.length - 1 ? '\n' : ''}
                    </span>
                );
            })}
        </Typography>
    );
};

// ─── View: Assistente ─────────────────────────────────────────────────────────
const BotMessageBubble = ({ message }) => {
    const isUser = message.from === 'user';
    return (
        <Box sx={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', mb: 1 }}>
            {!isUser && (
                <Avatar sx={{ width: 32, height: 32, bgcolor: COLORS.primary, mr: 1, mt: 0.5, flexShrink: 0 }}>
                    <SmartToyIcon sx={{ fontSize: 18 }} />
                </Avatar>
            )}
            <Box
                sx={{
                    maxWidth: '65%',
                    bgcolor: isUser ? COLORS.userBubble : COLORS.botBubble,
                    px: 1.5, py: 1,
                    borderRadius: isUser ? '12px 12px 2px 12px' : '12px 12px 12px 2px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                }}>
                {isUser
                    ? <Typography sx={{ fontSize: 14, color: '#111', lineHeight: 1.5, whiteSpace: 'pre-line' }}>{message.text}</Typography>
                    : <BotText text={message.text} />
                }
                {message.link && <ChatLink link={message.link} />}
                <Typography sx={{ fontSize: 10, color: COLORS.greyDark, textAlign: 'right', mt: 0.3 }}>{message.time}</Typography>
            </Box>
        </Box>
    );
};

const BotView = () => {
    const { messages, input, handleInputChange, handleSend, handleKeyDown } = useChatMessages();
    const bottomRef = useRef(null);

    useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, bgcolor: COLORS.primary, flexShrink: 0 }}>
                <Avatar sx={{ bgcolor: COLORS.primaryDark, width: 42, height: 42 }}>
                    <SmartToyIcon />
                </Avatar>
                <Box>
                    <Typography sx={{ fontWeight: 600, color: COLORS.white, lineHeight: 1.2 }}>Assistente Empiria</Typography>
                    <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,0.85)' }}>online</Typography>
                </Box>
            </Box>

            <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 2, bgcolor: COLORS.bg, display: 'flex', flexDirection: 'column' }}>
                {messages.map(msg => <BotMessageBubble key={msg.id} message={msg} />)}
                <div ref={bottomRef} />
            </Box>

            <Box sx={{ px: 2, py: 1.5, bgcolor: COLORS.white, borderTop: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
                <TextField
                    fullWidth
                    placeholder="Digite uma opção..."
                    value={input}
                    onChange={e => handleInputChange(e.target.value)}
                    onKeyDown={handleKeyDown}
                    multiline maxRows={4} size="small"
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: '24px', bgcolor: COLORS.bg } }}
                />
                <IconButton
                    onClick={handleSend}
                    disabled={!input.trim()}
                    sx={{ bgcolor: COLORS.primary, color: COLORS.white, '&:hover': { bgcolor: COLORS.primaryDark }, '&.Mui-disabled': { bgcolor: '#ccc', color: '#fff' }, width: 44, height: 44, flexShrink: 0 }}>
                    <SendIcon fontSize="small" />
                </IconButton>
            </Box>
        </>
    );
};

// ─── View: WhatsApp ───────────────────────────────────────────────────────────
const WaMessageBubble = ({ message }) => {
    const isUser = message.from === 'user';
    return (
        <Box sx={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', mb: 0.5, px: 2 }}>
            <Box
                sx={{
                    position: 'relative',
                    maxWidth: '65%',
                    bgcolor: isUser ? WA.sentBubble : WA.receivedBubble,
                    px: 1.5, pt: 0.75, pb: 0.25,
                    borderRadius: isUser ? '8px 0px 8px 8px' : '0px 8px 8px 8px',
                    boxShadow: '0 1px 1px rgba(0,0,0,0.13)',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        ...(isUser
                            ? { right: -8, borderWidth: '0 0 8px 8px', borderColor: `transparent transparent transparent ${WA.sentBubble}` }
                            : { left: -8, borderWidth: '0 8px 8px 0', borderColor: `transparent ${WA.receivedBubble} transparent transparent` }),
                        borderStyle: 'solid',
                        width: 0, height: 0,
                    },
                }}>
                {isUser
                    ? <Typography sx={{ fontSize: 14, color: '#111', lineHeight: 1.5, wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{message.text}</Typography>
                    : <BotText text={message.text} />
                }
                {message.link && <ChatLink link={message.link} />}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 0.25, mt: 0.25 }}>
                    <Typography sx={{ fontSize: 11, color: WA.timestamp }}>{message.time}</Typography>
                    {isUser && (
                        <Typography sx={{ fontSize: 11, color: '#53bdeb', lineHeight: 1 }}>✓✓</Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

const WhatsAppView = () => {
    const { messages, input, handleInputChange, handleSend, handleKeyDown } = useChatMessages();
    const bottomRef = useRef(null);

    useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

    return (
        <>
            {/* Header estilo WhatsApp */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: 1, bgcolor: WA.header, flexShrink: 0, borderBottom: '1px solid #d1d7db' }}>
                <IconButton size="small" sx={{ color: WA.icon }}>
                    <ArrowBackIcon fontSize="small" />
                </IconButton>
                <Avatar src={`${process.env.PUBLIC_URL}/favicon.ico`} sx={{ width: 40, height: 40 }} />
                <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Typography sx={{ fontWeight: 600, fontSize: 15, color: WA.headerText, lineHeight: 1.2 }}>Empiria</Typography>
                        <VerifiedIcon sx={{ fontSize: 15, color: '#25d366' }} />
                    </Box>
                    <Typography sx={{ fontSize: 12, color: WA.headerSub }}>online</Typography>
                </Box>
                <IconButton size="small" sx={{ color: WA.icon }}><SearchIcon fontSize="small" /></IconButton>
                <IconButton size="small" sx={{ color: WA.icon }}><MoreVertIcon fontSize="small" /></IconButton>
            </Box>

            {/* Área de mensagens */}
            <Box sx={{ flex: 1, overflowY: 'auto', py: 1, backgroundImage: `url(${process.env.PUBLIC_URL}/whatsapp_wallpaper.png)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', display: 'flex', flexDirection: 'column' }}>
                {messages.map(msg => <WaMessageBubble key={msg.id} message={msg} />)}
                <div ref={bottomRef} />
            </Box>

            {/* Input estilo WhatsApp */}
            <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, px: 1.5, py: 1, bgcolor: WA.inputArea, flexShrink: 0 }}>
                <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-end', bgcolor: WA.inputField, borderRadius: '24px', px: 1.5, boxShadow: '0 1px 2px rgba(0,0,0,0.08)' }}>
                    <TextField
                        fullWidth
                        placeholder="Digite uma opção..."
                        value={input}
                        onChange={e => handleInputChange(e.target.value)}
                        onKeyDown={handleKeyDown}
                        multiline maxRows={4}
                        variant="standard"
                        InputProps={{ disableUnderline: true }}
                        sx={{ '& .MuiInputBase-root': { fontSize: 14, py: 0.75 } }}
                    />
                    <IconButton size="small" sx={{ color: WA.icon, p: 0.75 }}>
                        <AttachFileIcon fontSize="small" />
                    </IconButton>
                </Box>
                <IconButton
                    onClick={handleSend}
                    disabled={!input.trim()}
                    sx={{ bgcolor: WA.sendBtn, color: '#fff', '&:hover': { bgcolor: '#008f72' }, '&.Mui-disabled': { bgcolor: '#ccc' }, width: 44, height: 44, flexShrink: 0 }}>
                    <SendIcon fontSize="small" />
                </IconButton>
            </Box>
        </>
    );
};

// ─── Página principal ─────────────────────────────────────────────────────────
const ChatBot = () => {
    const { logged } = useAuth();

    return (
        <>
            {logged ? <Header /> : <LandingNavbar />}
            <Box sx={{ height: 'calc(100vh - 64px)', bgcolor: COLORS.bg, display: 'flex', alignItems: 'stretch', justifyContent: 'center', py: 3 }}>
                <Box sx={{ width: { xs: '95%', md: '70%' }, display: 'flex', flexDirection: 'column', borderRadius: 2, overflow: 'hidden', boxShadow: '0 2px 12px rgba(0,0,0,0.1)' }}>
                    <WhatsAppView />
                </Box>
            </Box>
        </>
    );
};

export default ChatBot;
